import type { ApplicantCount } from 'src/graphql/graphql';
import { useApplicantCountFeatureFlag } from 'src/hooks/experiments/hooks';

export const useNumberOfApplicants = (applicantCount: ApplicantCount) => {
  const { countLabel, volumeLabel } = applicantCount;

  const applicationVolumeJdpFeatureFlag = useApplicantCountFeatureFlag();
  const applicationVolumeLabel = getNumberOfApplicantsLabel({
    countLabel,
    volumeLabel,
    flag: applicationVolumeJdpFeatureFlag,
  });

  return {
    applicationVolumeLabel,
  };
};

export const getNumberOfApplicantsLabel = ({
  countLabel,
  volumeLabel,
  flag,
}: {
  countLabel?: string | null;
  volumeLabel?: string | null;
  flag: ReturnType<typeof useApplicantCountFeatureFlag>;
}): string | undefined => {
  switch (flag) {
    case 'control':
      return undefined;

    case 'volume':
      return volumeLabel ?? undefined;

    case 'count':
      return countLabel ?? undefined;

    default:
      return undefined;
  }
};
